module.exports = "/_next/static/images/kickoff-logo-light-876a66e15024c657796fa095f0998ba6.svg";